import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'

import { useUploadFile } from './useUploadFile'

const document = graphql(`
  mutation DataSettingsPage_GenerateQuestionnaireUploadURL(
    $surveyId: String!
    $filename: String!
    $dataType: String!
    $fileExtension: String!
  ) {
    generateUploadURL: generateQuestionnaireUploadURL(
      surveyId: $surveyId
      filename: $filename
      marketingResearchFirm: $dataType
      fileExtension: $fileExtension
    ) {
      url
      awaitId
    }
  }
`)

export const useUploadQuestionFile = () => {
  const { t } = useTranslation()

  return useUploadFile({
    document,
    messages: {
      error: t('could_not_upload_questionnaire_data'),
      uploading: t('uploading_questionnaire_data'),
      uploaded: t('questionnaire_data_uploaded'),
      logEvent: 'Upload question data',
    },
  })
}
